import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandler, HandleError } from '../http-error-handler.service';

import { Config } from '../config';
import { DewAuthService } from 'src/authentication/core/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiPeopleService {
  private handleError: HandleError;

  private httpOptions = null;
  constructor(
    private http: HttpClient,
    private authService: DewAuthService,
    httpErrorHandler: HttpErrorHandler,
    private sanitizer: DomSanitizer
  ) {
    this.handleError = httpErrorHandler.createHandleError('ApiService');

    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.authService.authToken,
      }),
    };
  }

  getAllPeople(gridProperties): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllUsers';
    var request: any = {};
    request.gridProperties = gridProperties;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllUsers', request)));
  }

  getAllDepartments(gridProperties, masterClientGetId,status): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllDepartments';
    var request: any = {};
    request.gridProperties = gridProperties;
    request.masterClientGetId = masterClientGetId
    request.status = status
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllDepartments', request)));
  }


  insertPeopleDetails(peopleDetails, masterClientGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/createUser';
    var request: any = {};
    request = peopleDetails;
    request.masterClientGetId = masterClientGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('createUser', request)));
  }

  getDepartmentDetailsByDepartmentId(departmentGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getDepartmentByDepartmentId';
    var request: any = {};
    request.departmentGetId = departmentGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('getDepartmentByDepartmentId', request))
      );
  }

  getDesignationDetailsByDesignationId(designationGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getDesignationByDesignationId';
    var request: any = {};
    request.designationGetId = designationGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('getDesignationByDesignationId', request))
      );
  }

  updatePeopleDetails(peopleDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateUserByUserId';
    var request: any = {};
    request = peopleDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('updateUserByUserId', request)));
  }
  
  updateUserStatus(peopleDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateUserStatusById';
    var request: any = {};
    request = peopleDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('updateUserStatusById', request)));
  }

  updateUserAccess(peopleDetails): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/updateUserAccessById';
    var request: any = {};
    request = peopleDetails;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('updateUserAccessById', request)));
  }
  
  getAllDesignations(gridProperties, masterClientGetId, status): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getAllDesignations';
    var request: any = {};
    request.gridProperties = gridProperties;
    request.masterClientGetId = masterClientGetId;
    request.status = status;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getAllDesignations', request)));
  }

  getUserDetails(userGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getUserByUserId';
    var request: any = {};
    request.userGetId = userGetId;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getUserByUserId', request)));
  }
  
  getUserByMasterClientId(masterClientGetId, search, isActive): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getUserByMasterClientId';
    var request: any = {};
    request.masterClientGetId = masterClientGetId;
    request.search = search;
    request.isActive = isActive;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getUserByMasterClientId', request)));
  }

  getUserNameByMasterClientId(masterClientGetId, status): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getUserByMasterClientId';
    var request: any = {};
    request.masterClientGetId = masterClientGetId;
    request.isActive = status
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('getUserByMasterClientId', request)));
  }

  changePassword(request) {
    let url = Config.ServiceBaseUrl + 'api/changePassword';
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('changePassword', request)));
  }

  resendInviteLink(requests): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/resendInviteLink';
    var request: any = {};
    request = requests;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(catchError(this.handleError('resendInviteLink', request)));
  }

  getResourcesByDepartmentId(haveAccessToDepartment, search, departmentGetId, ResourceStatus, userGetId): Observable<any> {
    var url = Config.ServiceBaseUrl + 'api/getResourcesByDepartmentId';
    var request: any = {};
    request.haveAccessToDepartment = haveAccessToDepartment;
    request.departmentGetId = departmentGetId;
    request.isActive = ResourceStatus;
    request.userGetId = userGetId;
    request.search = search;
    return this.http
      .post(url, request, this.httpOptions)
      .pipe(
        catchError(this.handleError('getResourcesByDepartmentId', request))
      );
  }
}
